import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.scss";

export default function VideoDescriptionItem({ item }) {

    const [t] = useTranslation();

    const truncateDescription = (description) => {
        if (typeof description !== "string") {
            return "";
        }
        if (description.length <= 120) {
            return description;
        }
        return `${description.slice(0, 120)}...`;
    };

    return (
        <Link to={`/videos/video/${item.id}/info`}>
            <div className="organisation-list-item">
                <div className="organisation-list-item-rows">
                    <div className="organisation-list-item-row">
                        <div className="organisation-list-item-column">
                            <div className="item is-bold is-center">
                                {item.title}
                            </div>
                        </div>
                    </div>
                    <div className="organisation-list-item-row">
                        <div className="organisation-list-item-column">
                            <div className="label">
                                {t("book.edit.invitation.approval.status")}
                            </div>
                            <div className={`item approval-status ${item.published ? "approved" : "neutral"}`}>
                                {item.published ? "Published" : "Draft"}
                            </div>
                        </div>
                    </div>
                    <div className="organisation-list-item-row">
                        <div className="organisation-list-item-column">
                            <div className="label">
                                {t("book.edit.invitation.approval.message")}
                            </div>
                            <div className="item description-preview">
                                {truncateDescription(item.description)}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>);
}

VideoDescriptionItem.propTypes = {
    item: PropTypes.object.isRequired
};
